export default "__VITE_ASSET__n5F7DA_6__"